import { render } from "./ScrollPane.vue?vue&type=template&id=31f47504&scoped=true"
import script from "./ScrollPane.vue?vue&type=script&lang=ts"
export * from "./ScrollPane.vue?vue&type=script&lang=ts"

import "./ScrollPane.vue?vue&type=style&index=0&id=31f47504&lang=scss&scoped=true"
import "./ScrollPane.vue?vue&type=style&index=1&id=31f47504&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31f47504"

export default script